import { createFileRoute, redirect } from '@tanstack/react-router'
import { HR_PAGE_READ, HR_TABS } from '~/components/routes/hr/tabs'
import { resolveMissingPermissions, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/hr/planning/')({
  staticData: {
    permission: HR_PAGE_READ,
  },
  beforeLoad: ({ context }) => {
    // Pas de hooks dans un `beforeLoad` : la version pure de la résolution des droits.
    const first = HR_TABS.find(
      (tab) => resolveMissingPermissions(context.ability, tab.permission).length === 0,
    )

    throw redirect({
      to: '/hr/planning/$tab',
      params: { tab: first?.value ?? HR_TABS[0].value },
    })
  },
})
withRoutePermissions(Route)
